module.exports = require('./helpers/bundle-url').getBundleURL('cqLDD') + "FleetOverview_Icon.ea886e8f.png";